<template>

  <div class="ui inverted segment">
    <div class="ui inverted header">
      <i class="user icon"/>
      {{ localization.studyIdentifier.studyIdentifierTitle }}
    </div>

    <div class="ui form">
      <label>{{ localization.studyIdentifier.studyIdentifierLabel }}</label>
      <div class="ui fluid input">
        <input
          v-model="currentUserStudyIdentifier"
          type="text">
      </div>

      <br>
      <label>{{ localization.studyIdentifier.studyGenderLabel }}</label>
      <div class="grouped fields">
        <div class="field">
          <div class="ui radio checkbox">
            <input
              id="female"
              v-model="currentUserStudyGender"
              type="radio"
              name="gender"
              value="female"
              checked="checked">
            <label for="female">{{ localization.studyIdentifier.studyGenderFemale }}</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input
              id="male"
              v-model="currentUserStudyGender"
              type="radio"
              name="gender"
              value="male">
            <label for="male">{{ localization.studyIdentifier.studyGenderMale }}</label>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="hasError"
      class="ui negative small message"
      v-html="errorText">
    </div>
    <br v-else>

    <div
      class="ui right floated tertiary circular button"
      @click="updateConfirmation(true)"> {{ localization.global.next }} <i class="chevron right icon"/>
    </div>
    <br>
    <br>
  </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from 'vuelidate/lib/validators'
const SQUARE_FORMAT = helpers.regex('SQUARE_FORMAT', /^[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9]$/)

export default {
  name: 'BaselineInput',
  data () {
    return {
      currentUserStudyIdentifier: null,
      currentUserStudyGender: null,
      hasError: false,
      errorText: ''
    }
  },
  validations: {
    currentUserStudyIdentifier: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(8),
      SQUARE_FORMAT
    },
    currentUserStudyGender: {
      required
    }
  },
  methods: {
    updateConfirmation (val) {
      this.hasError = false

      if (typeof (val) !== 'boolean') {
        Rollbar.critical('Update confirmation screen is not a Boolean', val)
      }
      if (val === true && this.$v.$invalid) {
        this.hasError = true
        if (this.$v.currentUserStudyIdentifier.required === false) {
          this.errorText = this.localization.errorMessages.emptyStudyIdentifier
        } else {
          this.errorText = this.localization.errorMessages.invalidStudyIdentifier
        }

        if (this.$v.currentUserStudyGender.required === false) {
          this.errorText = this.errorText.concat(this.localization.errorMessages.emptyStudyGender)
        }

      } else {
        this.$emit('updateConfirmation', val)
        this.$emit('updateUserStudyIdentifier', this.currentUserStudyIdentifier)
        this.$emit('updateUserStudyGender', this.currentUserStudyGender)
      }
    }
  }
}
</script>

<style scoped>
  label {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/study/BaselineInput.vue